module.exports = __webpack_public_path__ + "img/194.e07b0aeb.jpg";